import {useEffect} from 'react';
import {Grid, Checkbox} from '@material-ui/core';
import CircleIcon from '@mui/icons-material/Circle';
import {ImageDirian} from '../../assets';
import '../../assets/styles/checkBoxSelection.scss';
import {Language} from '../../context/LanguageContext';
export default function CheckBoxLaporanKerja({
  data,
  onSelectionChange,
  selected,
  isOneSelection,
}) {
  const {newObj, language} = Language();
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  const handleChange = (event) => {
    // const {id} = event.target;
    // setData(
    //   data.map((item) =>
    //     item.id === id ? {...item, checked: !item.checked} : item
    //   )
    // );
  };

  return (
    <Grid container spacing={2} className='check_box_selection_container'>
      {data.map((option) => (
        <Grid item xs={12} sm={6} md={4} lg={4} key={option.label}>
          <div
            style={{
              background: '#2B5180',
              color: ' white',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderRadius: '15px',
              padding: '14px 0',
            }}
          >
            <div
              style={{
                width: 'calc(100% - 10px)',
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
              }}
            >
              <img
                src={ImageDirian}
                alt={option.name}
                style={{
                  width: '40px',
                  height: '40px',
                  aspectRatio: 1,
                  borderRadius: '10px',
                  marginLeft: '10px',
                }}
              />
              <div className='check_box_selection_text'>
                <div className='top_text'>{option.jenisKerja}</div>
                <div className='bottom_text'>
                  {newObj.DateWord[language]}: {formatDate(option.created_at)}
                </div>
              </div>
            </div>
            {/* <div
              style={{
                backgroundColor: '#3A5C86',
                padding: '14px 7px',
                borderRadius: '0 10px 10px  0 ',
              }}
            >
              <Checkbox
                checked={
                  isOneSelection ? selected?.id === option?.id : option.checked
                }
                onClick={() => {
                  onSelectionChange(option);
                }}
                id={option.id}
                icon={
                  <CircleIcon
                    style={{color: 'white', width: '20px', height: '20px'}}
                  />
                }
                value={option.kodKawasan}
                checkedIcon={
                  <CircleIcon
                    style={{
                      color: 'blue',
                      border: 'white 5px solid',
                      borderRadius: '50%',
                      width: '20px',
                      height: '20px',
                    }}
                  />
                }
                color='primary'
                shape='circle'
              />
            </div> */}
          </div>
        </Grid>
      ))}
    </Grid>
  );
}
